import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'types/Field';
import RowBuilder, { getClasses, RowBuilderProps } from '../RowBuilder';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import PlusCircleIcon from 'components/Common/Icons/PlusCircle';
import MinusCircleIcon from 'components/Common/Icons/MinusCircle';

import styles from './RowAddressBuilder.module.scss';

type Props = RowBuilderProps & { field: { fields: Field[] } };

export default function RowAddressBuilder({
  field: { fields, classes },
  styles: parentStyles,
}: Props): JSX.Element {
  const classesObj = getClasses(classes, parentStyles) || {};
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [streetField, ...otherFields] = fields;

  return (
    <div className={classesObj?.row}>
      <p>{t('LABEL_MY_SHIPPING_ADDRESS')}</p>
      <RowBuilder field={streetField} />
      <Accordion
        elevation={0}
        square
        expanded={expanded}
        onChange={() => setExpanded(expended => !expended)}
        classes={{
          root: styles.accordionRoot,
          expanded: styles.accordionExpanded,
        }}
      >
        <AccordionSummary
          expandIcon={expanded ? <MinusCircleIcon /> : <PlusCircleIcon />}
          classes={{
            root: styles.accordionSummaryRoot,
            content: styles.accordionSummaryContent,
            expandIcon: styles.accordionSummaryIcon,
            expanded: styles.accordionSummaryExpanded,
          }}
        >
          {t('LABEL_ADD_ADDITIONAL_ADDRESS')}
        </AccordionSummary>
        <AccordionDetails classes={{ root: styles.accordionDetails }}>
          {otherFields.map(field => (
            <RowBuilder key={field.name} field={field} />
          ))}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
